"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("./util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DEFAULT_NODE_SELECTOR = 'tr';
var DIRECTIONS = {
  TOP: 1,
  BOTTOM: 3
};
var UNIT_PX = 'px';
var DRAG_LIND_STYLE = 'position:fixed;z-index:9999;height:0;' + 'margin-top:-1px;border-bottom:dashed 2px red;display:none;';
var ReactDragListView = /*#__PURE__*/function (_Component) {
  function ReactDragListView(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ReactDragListView);
    _this = _callSuper(this, ReactDragListView, [props]);
    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragEnd = _this.onDragEnd.bind(_this);
    _this.autoScroll = _this.autoScroll.bind(_this);
    _this.state = {
      fromIndex: -1,
      toIndex: -1
    };
    _this.scrollElement = null;
    _this.scrollTimerId = -1;
    _this.direction = DIRECTIONS.BOTTOM;
    return _this;
  }
  (0, _inherits2.default)(ReactDragListView, _Component);
  return (0, _createClass2.default)(ReactDragListView, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dragLine && this.dragLine.parentNode) {
        this.dragLine.parentNode.removeChild(this.dragLine);
        this.dragLine = null;
        this.cacheDragTarget = null;
      }
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var handle = this.getHandleNode(e.target);
      if (handle) {
        var target = !this.props.handleSelector || this.props.handleSelector === this.props.nodeSelector ? handle : this.getDragNode(handle);
        if (target) {
          handle.setAttribute('draggable', false);
          target.setAttribute('draggable', true);
          target.ondragstart = this.onDragStart;
          target.ondragend = this.onDragEnd;
        }
      }
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e) {
      var target = this.getDragNode(e.target);
      var eventData = e;
      if (target) {
        var parentNode = target.parentNode;
        eventData.dataTransfer.setData('Text', '');
        eventData.dataTransfer.effectAllowed = 'move';
        parentNode.ondragenter = this.onDragEnter;
        parentNode.ondragover = function (ev) {
          ev.preventDefault();
          return true;
        };
        var fromIndex = (0, _util.getDomIndex)(target, this.props.ignoreSelector);
        this.setState({
          fromIndex: fromIndex,
          toIndex: fromIndex
        });
        this.scrollElement = (0, _util.getScrollElement)(parentNode);
        if (this.props.onDragStart) {
          this.props.onDragStart(fromIndex - 1);
        }
      }
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(e) {
      var target = this.getDragNode(e.target);
      var eventData = e;
      var toIndex;
      if (target) {
        toIndex = (0, _util.getDomIndex)(target, this.props.ignoreSelector);
        if (this.props.enableScroll) {
          this.resolveAutoScroll(eventData, target);
        }
        if (this.props.onDragEnter) {
          this.props.onDragEnter(toIndex - 1);
        }
      } else {
        toIndex = -1;
        this.stopAutoScroll();
      }
      this.cacheDragTarget = target;
      this.setState({
        toIndex: toIndex
      });
      this.fixDragLine(target);
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(e) {
      var target = this.getDragNode(e.target);
      this.stopAutoScroll();
      if (target) {
        target.removeAttribute('draggable');
        target.ondragstart = null;
        target.ondragend = null;
        target.parentNode.ondragenter = null;
        target.parentNode.ondragover = null;
        if (this.props.onDragEnd) {
          this.props.onDragEnd(this.state.fromIndex - 1);
        }
        if (this.props.onDrop) {
          this.props.onDrop(this.state.fromIndex - 1, this.state.toIndex - 1);
        }
        if (this.state.fromIndex >= 0 && this.state.fromIndex !== this.state.toIndex) {
          this.props.reorderByIndexes(this.state.fromIndex, this.state.toIndex);
        }
      }
      this.hideDragLine();
      this.setState({
        fromIndex: -1,
        toIndex: -1
      });
    }
  }, {
    key: "getDragNode",
    value: function getDragNode(target) {
      return (0, _util.closest)(target, this.props.nodeSelector, this.dragList);
    }
  }, {
    key: "getHandleNode",
    value: function getHandleNode(target) {
      return (0, _util.closest)(target, this.props.handleSelector || this.props.nodeSelector, this.dragList);
    }
  }, {
    key: "getDragLine",
    value: function getDragLine() {
      if (!this.dragLine) {
        this.dragLine = window.document.createElement('div');
        this.dragLine.setAttribute('style', DRAG_LIND_STYLE);
        window.document.body.appendChild(this.dragLine);
      }
      this.dragLine.className = this.props.lineClassName || '';
      return this.dragLine;
    }
  }, {
    key: "resolveAutoScroll",
    value: function resolveAutoScroll(e, target) {
      if (!this.scrollElement) {
        return;
      }
      var _this$scrollElement$g = this.scrollElement.getBoundingClientRect(),
        top = _this$scrollElement$g.top,
        height = _this$scrollElement$g.height;
      var targetHeight = target.offsetHeight;
      var pageY = e.pageY;
      var compatibleHeight = targetHeight * (2 / 3);
      this.direction = 0;
      if (pageY > top + height - compatibleHeight) {
        this.direction = DIRECTIONS.BOTTOM;
      } else if (pageY < top + compatibleHeight) {
        this.direction = DIRECTIONS.TOP;
      }
      if (this.direction) {
        if (this.scrollTimerId < 0) {
          this.scrollTimerId = setInterval(this.autoScroll, 20);
        }
      } else {
        this.stopAutoScroll();
      }
    }
  }, {
    key: "stopAutoScroll",
    value: function stopAutoScroll() {
      clearInterval(this.scrollTimerId);
      this.scrollTimerId = -1;
      this.fixDragLine(this.cacheDragTarget);
    }
  }, {
    key: "autoScroll",
    value: function autoScroll() {
      var scrollTop = this.scrollElement.scrollTop;
      if (this.direction === DIRECTIONS.BOTTOM) {
        this.scrollElement.scrollTop = scrollTop + this.props.scrollSpeed;
        if (scrollTop === this.scrollElement.scrollTop) {
          this.stopAutoScroll();
        }
      } else if (this.direction === DIRECTIONS.TOP) {
        this.scrollElement.scrollTop = scrollTop - this.props.scrollSpeed;
        if (this.scrollElement.scrollTop <= 0) {
          this.stopAutoScroll();
        }
      } else {
        this.stopAutoScroll();
      }
    }
  }, {
    key: "hideDragLine",
    value: function hideDragLine() {
      if (this.dragLine) {
        this.dragLine.style.display = 'none';
      }
    }
  }, {
    key: "fixDragLine",
    value: function fixDragLine(target) {
      var dragLine = this.getDragLine();
      if (!target || this.state.fromIndex < 0 || this.state.fromIndex === this.state.toIndex) {
        this.hideDragLine();
        return;
      }
      var _target$getBoundingCl = target.getBoundingClientRect(),
        left = _target$getBoundingCl.left,
        top = _target$getBoundingCl.top,
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;
      var lineTop = this.state.toIndex < this.state.fromIndex ? top : top + height;
      if (this.props.enableScroll && this.scrollElement) {
        var _this$scrollElement$g2 = this.scrollElement.getBoundingClientRect(),
          scrollHeight = _this$scrollElement$g2.height,
          scrollTop = _this$scrollElement$g2.top;
        if (lineTop < scrollTop - 2 || lineTop > scrollTop + scrollHeight + 2) {
          this.hideDragLine();
          return;
        }
      }
      dragLine.style.left = left + UNIT_PX;
      dragLine.style.width = width + UNIT_PX;
      dragLine.style.top = lineTop + UNIT_PX;
      dragLine.style.display = 'block';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        role: "presentation",
        onMouseDown: this.onMouseDown,
        ref: function ref(c) {
          _this2.dragList = c;
        }
      }, this.props.children);
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(ReactDragListView, "propTypes", {
  reorderByIndexes: _propTypes.default.func.isRequired,
  handleSelector: _propTypes.default.string,
  nodeSelector: _propTypes.default.string,
  ignoreSelector: _propTypes.default.string,
  enableScroll: _propTypes.default.bool,
  scrollSpeed: _propTypes.default.number,
  lineClassName: _propTypes.default.string,
  children: _propTypes.default.node,
  onDragEnd: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDragEnter: _propTypes.default.func
});
(0, _defineProperty2.default)(ReactDragListView, "defaultProps", {
  nodeSelector: DEFAULT_NODE_SELECTOR,
  ignoreSelector: '',
  enableScroll: true,
  scrollSpeed: 10,
  handleSelector: '',
  lineClassName: '',
  children: null
});
var _default = exports.default = ReactDragListView;